<!--
 * @FilePath: \ioc_base\src\components\common\gis\index.vue
-->
<template>
  <!-- :style="mapStyle" -->
  <div id="map-container" class="map-container">
    <div id="igisWindowMarker" class="markerPop" style="position: relative; z-index: 1000"></div>
    <div class="map-component" ref="cimMapContent2D" id="cimMapContent2D" v-if="divId == 'cimMapContent2D'"></div>
    <div class="map-component" ref="cimMapContent2D" :id="divId" v-if="divId != 'cimMapContent2D'"></div>
  </div>
</template>

<script>
import Vue from "vue";
import mixinMap from "./mixinMap";
import deviceTip from "./components/deviceTip";
import circleRange from "./components/circleRange";
import deviceDetailTip from "./components/deviceDetailTip";
import polygonTip from "./components/polygonTip";
import trackTip from "./components/trackTip";
import utils from "$utils";
import { api } from "@src/modules/realTimeAlarm/api";
export default {
  name: "IGis",
  components: {},
  mixins: [mixinMap],
  props: {
    divId: {
      type: String,
      default: "cimMapContent2D",
    },
    // 默认中心点
    center: {
      type: Array,
      default: () => [],
    },
    // 默认等级
    zoom: {
      type: Number,
      default: () => 18,
    },
  },
  watch: {
    Adapater: {
      handler(val) {
        if (!val) {
          return;
        }
        if (window.iGis) {
          this.initJs();
        } else {
          setTimeout(() => {
            this.initJs();
          }, 500);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      tableData: Object.freeze([]),
      vueComponents: {},
      map: null,
      // 地图服务IP
      serverHeader: window.systemConfig.MAP_SERVERS.serverHeader, //"http://10.40.147.56:10001",
      wxsService: window.systemConfig.MAP_SERVERS.wxsService, // "/com.cloud.isoft.wxs.service",
      parkUrlm: window.systemConfig.MAP_SERVERS.parkUrlm, // "/WMSServices/loadStdout?serviceName=lunanzhiyao_WMS",
      mapCenter: [118.295943, 35.06282],
      mapCenterPoint: window.systemConfig.MAP_SERVERS.mapCenterPoint, // [118.296943, 35.06082],
      Adapater: null,
    };
  },
  computed: {},
  beforeDestroy() {
    window.removeEventListener("resize", this.refreshMap);
  },
  created() {
    this.Adapater = require("./adapter/IGis-adapter.js").default;
  },
  mounted() {
    this.vueComponents.trackTip = Vue.extend(trackTip);
    this.vueComponents.deviceDetailTip = Vue.extend(deviceDetailTip);
    this.vueComponents.circleRange = Vue.extend(circleRange);
    this.vueComponents.polygonTip = Vue.extend(polygonTip);
  },
  methods: {
    initJs() {
      console.log("1开始构造地图对象");
      this.map = new this.Adapater({
        mapType: iGis.MapType.WMS_MAP,
        divId: this.divId, // "cimMapContent2D",
        layerParams: {
          VERSION: "1.3.0",
          LAYERS: "gisserver",
        },
        url: this.serverHeader + this.wxsService + this.parkUrlm,
        center: this.mapCenterPoint, //鲁南中心
        zoom: 18,
        minZoom: 18,
        maxZoom: 22,
        projection: "EPSG:4326",
        isScaleLine: false, //是否显示比例尺
        isMousePosition: true, //是否显示鼠标当前坐标
        isZoomLevel: false, //是否显示级别
        isOverview: false, //是否开启鹰眼
        // units: "metric",
        // wrapX: true,
      });
      let mapBox = this.map.map;
      console.info("2地图构造器完成", this.map);
      if (this.map) {
        if (this.center.length) {
          mapBox.setMapCenter(this.center);
        }
        // 设置地图层级
        mapBox.setMapZoom(this.zoom);
        mapBox.addCustomClickEvent(function (e) {
          console.log("地图点击信息", e);
        });
        this.$emit("mapReady");

      } else {
        console.log("地图库未加载成功,请刷新页面重新加载！");
        this.initJs();
      }
      this.$nextTick(() => {
        window.addEventListener("resize", this.refreshMap);
      });
    },
    // 添加地图点击事件
    addClickEvent(callBack) {
      this.map.handleMapClickEvent(callBack);
    },
    // 添加地图右键点击事件
    addRightClickEvent(callBack) {
      this.map.handleMapRightClickEvent(callBack);
    },
    // 地图Event
    onMapEvent(eventName, callback) {
      this.mapEvents[eventName] = callback;
    },
    // 添加文字图层并打点
    addTextLayer(layerId, marker, click, minShowZoom) {
      this.map.addTextLayer(layerId, marker, click, minShowZoom);
    },
    // 移除文字图层
    removeFontLayer(layerId) {
      this.map.clearLayer(layerId);
    },
    // 添加图层并打点
    addMarket(option = [], layerId = "", click, hover) {
      this.map.addMarket(
        option,
        layerId,
        click || this.onClickCallback,
        hover || this.onHoverCallback
      );
    },
    // 添加热力图层并打点
    addHeatLayer(option = [], layerId = "", click) {
      this.map.addHeatLayer(option, layerId, click || this.onClickCallback);
    },
    // 添加汇聚图层并打点
    addClusterIconLayer(option = [], layerId = "", click) {
      this.map.ClusterIconLayer(option, layerId, click || this.onClickCallback);
    },

    // 根据图层标识，设置图层显示和隐藏
    setLayerVisibleById(layerId, visible = true) {
      this.map.setLayerVisibleById(layerId, visible);
    },
    // 根据图层标识，元素id 设置元素高亮
    setFeaHighlightById(layerId, ids) {
      this.map.setFeaHighlight(layerId, ids);
    },
    // 根据图层标识，id 设置图层元素属性
    updateFeatureById(layerId, featureId, obj) {
      this.map.updateFeatureById({
        layerId,
        featureId,
        obj,
      });
    },
    // 根据图层标识删除图层--推荐使用
    clearLayer(layerId) {
      this.map.clearLayer(layerId);
    },
    // 去除指定图标
    removePoint(layerId) {
      this.map.clearLayer(layerId);
    },
    // 去除全部图层
    clearPoint() {
      this.map.clearOverlays();
    },
    // 去除全部图层--推荐使用
    clearOverlays() {
      this.map && this.map.clearOverlays();
    },
    //动画效果
    addFlashMarket(option = [], layerId = "", click) {
      this.map.addFlashMarket(option, layerId, click);
    },
    // 飞行定位
    positionByPoint(point = this.mapCenterPoint) {
      this.map.setMapCenter(point);
    },
    // 设置地图中心点--推荐使用
    setMapCenter(center = this.mapCenterPoint) {
      this.map && this.map.setMapCenter(center);
    },
    // 默认打点图层事件
    onClickCallback({ layerId, marker, info } = arg) {
      // console.log("图标点击事件", layerId);
      // console.log("图层数据", marker);
      if (!marker.showTips) {
        console.log("当前点位不展示设备弹窗");
        return;
      }
      // 准备气泡数据
      let tipsAttr = [];
      for (let key in marker.tipsMap) {
        tipsAttr.push({
          label: marker.tipsMap[key],
          value: marker.attr[key],
        });
      }
      // 挂载在vue实例上
      this.addPopupMap({
        offset: [10, 10],
        position: marker.coord,
        content: '<div id="device_popup"></div>',
        contentId: "device_popup",
        layerId: "deviceTip",
      });
      // trackDetail
      let tipVue = null;
      tipVue = new Vue(deviceTip).$mount("#device_popup");

      tipVue.handleSetData({
        ...marker,
        tipsAttr,
      });
      tipVue.$on("tipClose", () => {
        this.$map.MapInstance2D.removePopup("deviceTip");
      });
    },
    // 默认悬停图层事件
    onHoverCallback({ layerId, marker, info } = arg) {
      // console.log("图标悬停事件", layerId, marker, info);
      let data = marker;
    },
    addPopupMap({
      offset = [],
      position = [],
      content = '<div id="gis_popup"></div>', //弹窗占位组件
      contentId = "gis_popup", //占位组件id，必须和content里的id保持一致
      layerId = "Tip", //弹窗标识
      isSingle = true, //一次是否显示一个
    } = arg) {
      console.log("标识", layerId);
      if (isSingle) {
        this.removePopup(layerId);
      }
      this.map.addPopupMap({ offset, position, content, contentId, layerId });
    },
    // 关闭弹窗,isAll 是否全删
    closeTips(layerId = "Tip", isAll = false) {
      this.map.removePopup(layerId, isAll);
    },
    // 关闭地图弹窗--推荐使用
    removePopup(layerId = "Tip", isAll = false) {
      this.map.removePopup(layerId, isAll);
    },
    // 设置地图级别
    setMapZoom(zoom) {
      this.map && this.map.setMapZoom(zoom);
    },
    //获取地图当前层级
    getMapZoom() {
      return this.map.getMapZoom();
    },
    //点击地图获取经纬度
    getLocation(callback) {
      const that = this;
      that.locationCB = callback;
      that.map.map.addCustomClickEvent(function (e) {
        console.log("地图点击信息", e);
        if (that.locationCB && typeof that.locationCB === "function") {
          that.locationCB({ clickType: "getLocation", ...e });
        }
      });
    },
    // 绘制圆圈
    addCircles(point, layerId, click) {
      this.map.addCircles(point, layerId, click || this.onClickCallback);
    },
    // 绘制OD线条
    drawTrajectory(layerId, point, Options, click) {
      this.map.addLine(layerId, point, Options, click);
    },
    // 绘制多边形
    addPolygon(id, color, data, label, click = null) {
      // 多边形图层会覆盖原地图点击事件，默认通过调用locationCB判断事件是否覆盖
      let onClickCallback = (e) => {
        let coord = e.info.clickCoord
        if (this.locationCB && typeof this.locationCB === "function") {
          this.locationCB({ clickType: "getLocation", ...coord });
        }
        if (click) {
          click()
        }
      }
      this.map.addPolygonLayer({
        layerId: id,
        isHover: false,
        click: onClickCallback,
        polygonData: [
          {
            id: id,
            coord: data, // coord,
            strokeColor: color, // 字体边线颜色
            fillColor: '#FFFFFF00',
            // label: label,
            strokeWidth: '3',
            labFillColor: 'white',
          },
        ],
      });
    },
    // 绘制大屏多边形
    addScreenPolygon({
                       layerId,
                       fillColor = "#FFCCFF",
                       strokeColor = "#fff",
                       polygonData,
                       click = null,
                     } = {}) {
      // 多边形图层会覆盖原地图点击事件，默认通过调用locationCB判断事件是否覆盖
      let onClickCallback = (e) => {
        let coord = e.info.clickCoord
        if (this.locationCB && typeof this.locationCB === "function") {
          this.locationCB({ clickType: "getLocation", ...coord });
        }
        if (click) {
          click(e)
        }
      }
      this.map.addPolygonLayer({
        layerId: layerId,
        fillColor,
        strokeColor,
        isHover: false,
        click: onClickCallback,
        polygonData: polygonData,
      });
    },
    // 绘制多边形-绘制过程
    drawFeature(callback) {
      this.map.drawFeatureMap(callback);
    },
    // 结束绘制多边形
    removeDrawFeature() {
      this.map.removeDrawFeature();
    },
    //去除球体等多边形
    clearShape(layerId) {
      this.map.clearLayer(layerId);
    },
    // 销毁地图并清理所有图层
    destroyLocation() {
      if (this.map) {
        this.map.destroyed();
      }
    },
    // 清除OD线条图层
    removeTrajectory(layerId) {
      this.clearLayer(layerId);
    },
    // 清空地图
    clear() {
      this.clearOverlays();
    },
    // 刷新地图
    refreshMap() {
      this.map.refreshMap();
    },
    //获取区域列表
    getAreaInfo() {
      const self = this;
      const account = utils.Cache.get("CACHE_USER_INFO");
      this.$fetch(api.list, {
        accountNumber: account.account,
      }).then((response) => {
        const result = self.menusDataPro(response.returnObj);
        self.tableData = Object.freeze(result);
        if (self.tableData != []) {
          this.treeDataArea(this.tableData);
        }
      });
    },
    // 递归渲染多个区域
    treeDataArea(data = []) {
      const self = this;
      data.forEach(function (item) {
        if (item.areaPointList.length) {
          self.checkAreaList = [];
          item.areaPointList.forEach((el) => {
            self.checkAreaList.push([Number(el.lng), Number(el.lat)]);
          });
          // TODO 区域取中心点位计算
          let addMarkInfo = [];
          let sumX = 0;
          let sumY = 0;
          let length = 0;
          self.checkAreaList.forEach(function (areaPoint) {
            sumX += areaPoint[0];
            sumY += areaPoint[1];
            length = self.checkAreaList.length; // 获取数组的长度
          });
          if (sumX != 0 & sumY != 0) {
            addMarkInfo.push({  // 区域取中心点位计算
              id: item.id,
              longitude: Number(),
              latitude: Number(),
              coord: [Number(sumX / length), Number(sumY / length)],
              anchor: [20, 20],
              scale: 1,
              isHover: true,
              src: "/images/theme/newDark/floor/" + item.name + ".png",
              sleSrc: "/images/theme/newDark/floor/" + item.name + ".png",
              attr: {
                ...item,
              },
            });
          }
          self.addPolygon(
            item.id,
            item.areaColor || "#846505",
            [self.checkAreaList],
            item.name
          );

          //区域名称打点
          self.addMarket(
            addMarkInfo,
            item.id + '_areaName',
            ''
          );
        }
        if (item.children) {
          self.treeDataArea(item.children);
        }
      });
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.areaDevGroupCode;
          entity.name = item.areaDevGroupName;
          entity.lng = item.lng;
          entity.lat = item.lat;
          entity.desc = item.desc;
          entity.areaPointList = item.areaPointList;
          entity.areaColor = item.areaColor;
          entity.isWorkShop = item.isWorkShop;
          entity.parentCode = item.parentCode;
          entity.personList = [].concat(item.ownerList);
          entity.personListKeeper = [].concat(item.personListKeeper || []);
          entity.ownerList = self.showOwnerList(item.ownerList);
          entity.keeperList = self.showOwnerList(item.keeperList || []);
          entity.isLeaf = !item.hasLeaf || !item.childrens;
          if (item.childrens) {
            entity.children = self.menusDataPro(item.childrens);
          }
          result.push(entity);
        });
        return result;
      }
    },
    showOwnerList(list) {
      return list.map((item) => item.personnelName).join(",");
    },
  },
};
</script>

<style scoped lang="scss">
@import "./styleMap.scss";
</style>
